export interface ParsedEvidenceBlock {
  excerpt: string;
  title: string;
  url: string;
  rcs?: number;
  level?: string;
  citations?: number;
  year?: number;
  journalQ?: number;
}

export interface AnswerSegment {
  kind: "text" | "evidence" | "fallback";
  content: string;
  evidence?: ParsedEvidenceBlock;
}

const META_RE =
  /\[score:\s*(\d+)\/10\s*·\s*Level\s*([IVX]+)\s*·\s*citations:\s*(\d+|—)\s*·\s*year:\s*(\d+|—)\s*·\s*journalQ:\s*(\d+\/5|—)\]/i;

export function parseAnswer(answer: string): AnswerSegment[] {
  if (!answer.trim()) return [];

  const segments: AnswerSegment[] = [];
  const blocks = answer.split(/(?=📄\s*")/);

  for (const block of blocks) {
    const trimmed = block.trim();
    if (!trimmed) continue;

    if (!trimmed.startsWith("📄")) {
      const prose = trimmed.replace(/<\/?consensus>[\s\S]*$/i, "").trim();
      if (prose) segments.push({ kind: "text", content: prose });
      continue;
    }

    try {
      const quoteMatch = trimmed.match(/📄\s*"([^"]+)"/);
      const titleMatch = trimmed.match(/—\s*(.+?)(?:\n|$)/);
      const urlMatch = trimmed.match(/(https?:\/\/[^\s]+)/);
      const metaMatch = trimmed.match(META_RE);

      if (!quoteMatch) {
        segments.push({ kind: "fallback", content: trimmed });
        continue;
      }

      const evidence: ParsedEvidenceBlock = {
        excerpt: quoteMatch[1],
        title: titleMatch?.[1]?.trim() ?? "Unknown source",
        url: urlMatch?.[1] ?? "",
      };

      if (metaMatch) {
        evidence.rcs = Number(metaMatch[1]);
        evidence.level = metaMatch[2];
        evidence.citations =
          metaMatch[3] === "—" ? undefined : Number(metaMatch[3]);
        evidence.year = metaMatch[4] === "—" ? undefined : Number(metaMatch[4]);
        const jq = metaMatch[5];
        evidence.journalQ = jq === "—" ? undefined : Number(jq.split("/")[0]);
      }

      segments.push({ kind: "evidence", content: "", evidence });
    } catch {
      segments.push({ kind: "fallback", content: trimmed });
    }
  }

  return segments;
}

export function stripConsensusTags(text: string): string {
  return text.replace(/<consensus>[\s\S]*?<\/consensus>/gi, "").trim();
}
